import HomePage from '../containers/home'
import LoginPage from '../containers/login'
import NotFoundPage from '../containers/not_found'
import EstimatePage from '../containers/estimate'
import PreviewPage from '../containers/preview'
import AuthorizePage from '../containers/authorize'

// routes for declare new pages
const routes = [
  { path: '/', component: HomePage, exact: true },
  { path: '/login', component: LoginPage, exact: true },
  { path: '/estimate/:id', component: EstimatePage, exact: true },
  { path: '/preview/:id', component: PreviewPage, exact: true },
  { path: '/authorize', component: AuthorizePage, exact: true },
  { path: '/not-found', component: NotFoundPage, exact: true },
  { component: NotFoundPage }
]

export default routes
